import Vue from "vue"
import VueRouter from 'vue-router'

import Login from "@/components/User/Login"
import Dashboard from "@/components/User/Dashboard"
import Dashboard2 from "@/components/User/Dashboard2"
import CardLists from "@/components/Cards/CardLists"
import CommandLists from "@/components/Command/CommandLists"
import CardMain from "@/components/Cards/CardMain"
import PendingMain from "@/components/Pending/PendingMain"
import LogMain from "@/components/Log/LogMain"
import UserMain from "@/components/User/Account/UserMain"
import WalletMain from "@/components/User/Wallet/WalletMain"
import PaydunyaMain from "@/components/User/Paydunya/PaydunyaMain"
import CommandMain from "@/components/Command/CommandMain"
import TrackingMain from "@/components/Tracking/TrackingMain"
import Cardhistory from "@/components/Cards/Cardhistory"
import Cardqueue from "@/components/Cards/Cardqueue"
import Cardcount from "@/components/Cards/Cardcount"
import Pendingcmd from "@/components/Command/Pendingcmd"
import Commandhistory from "@/components/Command/Commandhistory"
import Serverlogs from "@/components/Log/serverlogs"
import GestionAlertes from "@/components/Log/GestionAlertes"
import Serveraudits from "@/components/Log/serveraudits"
import Clientslogs from "@/components/Log/clientslogs"
import Userslists from "@/components/User/Userslists"
import TrackingLists from "@/components/Tracking/TrackingLists"
import InfosTPE from "@/components/Tracking/InfosTPE"
import StatutsTPE from "@/components/Tracking/StatutsTPE"
import Roles from "@/components/User/Account/Roles"
import Brigades from "@/components/User/Account/Brigades"
import Entreprises from "@/components/User/Wallet/Entreprises"
import Wallets from "@/components/User/Wallet/Wallets"
import MontantJourCumul from "@/components/User/Wallet/MontantJourCumul"
import NombreRepasCumul from "@/components/User/Wallet/NombreRepasCumul"
import EmployeeMessages from "@/components/User/Wallet/EmployeeMessages"
import QRCodePayment from "@/components/User/Wallet/QRCodePayment.vue"
import JoursOuvresAdmin from "@/components/User/Wallet/JoursOuvresAdmin"
import PaymentCallback from "@/components/User/Paydunya/PaymentCallback"
import PaymentCancel from "@/components/User/Paydunya/PaymentCancel"
import PaymentSuccess from "@/components/User/Paydunya/PaymentSuccess"
import PaymentInitiation from "@/components/User/Paydunya/PaymentInitiation"
import Cards from "@/components/User/Wallet/Cards"
import LienEntrepriseRestaurant from "@/components/User/Wallet/LienEntrepriseRestaurant"
import SubventionRules from "@/components/User/Wallet/SubventionRules"
import Sessions from "@/components/User/Wallet/Sessions"
import Terminaux from "@/components/User/Wallet/Terminaux"
import Sites from "@/components/User/Wallet/Sites"
import DispatchingRules from "@/components/User/Dispatching/DispatchingRules"
import DispatchingResults from "@/components/User/Dispatching/DispatchingResults"
import DispatchingResultsByAgent from "@/components/User/Dispatching/DispatchingResultsByAgent"
import DispatchingResultsByAgentPDF from "@/components/User/Dispatching/DispatchingResultsByAgentPDF"
import DispatchingResultsComDePerm from "@/components/User/Dispatching/DispatchingResultsComDePerm"
import Postes from "@/components/User/Dispatching/Postes"
import PlanningBrigades from "@/components/User/Planning/PlanningBrigades"
import Raisons from "@/components/User/Account/Raisons"
import Presences from "@/components/User/Planning/Presences"
import ModifsProvisoires from "@/components/User/Planning/ModifsProvisoires"
import ModifsPermanentes from "@/components/User/Planning/ModifsPermanentes"
import Shifts from "@/components/User/Planning/Shifts"
import Constantes from "@/components/User/Constantes"
import Absences from "@/components/User/Planning/Absences"
import HeuresSup from "@/components/User/Planning/HeuresSup"
import Menus from "@/components/User/Restauration/Menus"
import Commandes from "@/components/User/Restauration/Commandes"
import CommandesIndividuelles from "@/components/User/Restauration/CommandesIndividuelles"
import TransfertCommande from "@/components/User/Restauration/TransfertCommande"
import QuotePartsSalaries from "@/components/User/Restauration/QuotePartsSalaries"
import CashierDailyStats from "@/components/User/Restauration/CashierDailyStats"
import RapportsSalarie from "@/components/User/Restauration/RapportsSalarie"
import RapportsSalarieAdmin from "@/components/User/Restauration/RapportsSalarieAdmin"
import RapportsRestaurant from "@/components/User/Restauration/RapportsRestaurant"
import RapportsRestaurantAdmin from "@/components/User/Restauration/RapportsRestaurantAdmin"
import RapportsNdellice from "@/components/User/Restauration/RapportsNdellice"
import RapportsEntrepriseAdmin from "@/components/User/Restauration/RapportsEntrepriseAdmin"
import RapportsMaay from "@/components/User/Restauration/RapportsMaay"
import GenerationCodeEmail from "@/components/User/Account/GenerationCodeEmail"
import UserProfile from "@/components/User/Account/UserProfile"
import ChangeCredentials from "@/components/User/Account/ChangeCredentials"
import CommandesMultiples from "@/components/shop/Shop"
import PresencesPlanifiees from "@/components/User/Planning/PresencesPlanifiees"
import AbsencesJustifiees from "@/components/User/Planning/AbsencesJustifiees"
import PresencesNonPlanifiees from "@/components/User/Planning/PresencesNonPlanifiees"
import AbsencesNonJustifiees from "@/components/User/Planning/AbsencesNonJustifiees"
import PermissionsAgent from "@/components/User/Planning/PermissionsAgent"
import PermissionsGroup from "@/components/User/Planning/PermissionsGroup"
import FixationAgents from "@/components/User/Dispatching/FixationAgents"
import Licence from "@/components/User/Licence"
import Account from "@/components/User/Account/Account"
import AccountDetails from "@/components/User/Account/AccountDetails"
import cmdCards from "@/components/Cards/cmdCards"
import cmdPending from "@/components/Pending/cmdpending"
import NotFound from "@/components/NotFound"

// route-utils.js
import CryptoJS from 'crypto-js'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    component: Login,
    name: 'login',
    meta: {
        requiresAuth: false
    },
},
    {
        path: "/dashboard",
        component: Dashboard,
        name: "dashboard",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/dashboard2",
        component: Dashboard2,
        name: "dashboard2",
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: "/pending",
        component: PendingMain,
        children: [{
            path: "cmdpending",
            component: cmdPending,
            name: "cmdPending",
            meta: {
                requiresAuth: true,
            }
        }]
    },
    {
        path: '/cards',
        component: CardMain,
        children: [{
            path: "lists",
            component: CardLists,
            name: "cardsLists",
            meta: {
                title: "Liste des cartes",
                requiresAuth: true,
            }
        },

            {
                path: "cardhistory",
                component: Cardhistory,
                name: "cardshistory",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "cardqueue",
                component: Cardqueue,
                name: "cardsqueue",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: 'cardcount',
                component: Cardcount,
                name: "cardscount",
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: "cmdCards",
                component: cmdCards,
                name: "cmdCards",
                meta: {
                    requiresAuth: true,
                }
            }
        ]
    },
    {
        path: "/commands",
        component: CommandMain,
        children: [{
            path: "lists",
            component: CommandLists,
            name: "commandsLists",
            meta: {
                title: "Liste des commandes",
                requiresAuth: true,

            },

        },
            {
                path: "commandhistory",
                component: Commandhistory,
                name: "commandhistory",
                meta: {
                    title: "Historique des commandes",
                    requiresAuth: true,

                },

            },
            {
                path: "pendingcmd",
                component: Pendingcmd,
                name: "pendingcmd",
                meta: {
                    title: "Commandes retardées",
                    requiresAuth: true,
                }
            }
        ]
    },
    {
        path: "/logs",
        component: LogMain,
        children: [{
            path: "serverlogs",
            component: Serverlogs,
            name: "serverlogs",
            meta: {
                title: "Systeme de logs serveur",
                requiresAuth: true,
            },
        },
            {
                path: "serveraudits",
                component: Serveraudits,
                name: "serveraudits",
                meta: {
                    title: "Audits du système",
                    requiresAuth: true,
                }
            },
            {
                path: "clientslogs",
                component: Clientslogs,
                name: "clientslogs",
                meta: {
                    title: "Logs clients",
                    requiresAuth: true,

                }
            },
            {
                path: "gestionalertes",
                component: GestionAlertes,
                name: "gestionalertes",
                meta: {
                    title: "Gestion des alertes",
                    requiresAuth: true,
                }
            }
        ]
    },
    {
        path: "/wallet",
        component: WalletMain,
        children: [{
            path: "entreprises",
            component: Entreprises,
            name: "Entreprises",
            meta: {
                title: "Liste des entreprises",
                requiresAuth: true
            }
        }, {
            path: "sites",
            component: Sites,
            name: "Sites",
            meta: {
                title: "Liste des sites",
                requiresAuth: true
            }
        }, {
            path: "terminaux",
            component: Terminaux,
            name: "Terminaux",
            meta: {
                title: "Liste des terminaux",
                requiresAuth: true
            }
        }, {
            path: "sessions",
            component: Sessions,
            name: "Sessions",
            meta: {
                title: "Liste des sessions",
                requiresAuth: true
            }
        }, {
            path: "subventionrules",
            component: SubventionRules,
            name: "SubventionRules",
            meta: {
                title: "Liste des subventions",
                requiresAuth: true
            }
        }, {
            path: "lienentrepriserestaurant",
            component: LienEntrepriseRestaurant,
            name: "LienEntrepriseRestaurant",
            meta: {
                title: "Liste des affiliations",
                requiresAuth: true
            }
        }, {
            path: "cards",
            component: Cards,
            name: "Cards",
            meta: {
                title: "Liste des cartes",
                requiresAuth: true
            }
        }, {
            path: "montantjourcumul",
            component: MontantJourCumul,
            name: "MontantJourCumul",
            meta: {
                title: "Liste des montants cumulés par jour",
                requiresAuth: true
            }
        }, {
            path: "NombreRepasCumul",
            component: NombreRepasCumul,
            name: "NombreRepasCumul",
            meta: {
                title: "Liste du nombre de repas consommés par mois",
                requiresAuth: true
            }
        }, {
            path: "EmployeeMessages",
            component: EmployeeMessages,
            name: "EmployeeMessages",
            meta: {
                title: "Liste des messages postpone des salariés",
                requiresAuth: true
            }
        },  {
            path: "QRCodePayment",
            component: QRCodePayment,
            name: "QRCodePayment",
            meta: {
                title: "Paiement par QR Code",
                requiresAuth: true
            }
        }, {
            path: "jours-ouvres-admin",
            component: JoursOuvresAdmin,
            name: "JoursOuvresAdmin",
            meta: {
                title: "Administration des Jours Ouvrés",
                requiresAuth: true,
                requiresAdmin: true
            }
        }, {
            path: "wallets",
            component: Wallets,
            name: "Wallets",
            meta: {
                title: "Liste des wallets",
                requiresAuth: true
            }
        }
        ]
    },
    {
        path: "/paydunya",
        component: PaydunyaMain,
        children: [{
            path: 'paymentinitiation',
            name: 'paymentinitiation',
            component: PaymentInitiation,
            meta: {
                title: "Initialisation du paiement",
                requiresAuth: true
            }
        }, {
            path: "paymentcallback",
            component: PaymentCallback,
            name: "PaymentCallback",
            meta: {
                title: "Url de callback du paiement",
                requiresAuth: true
            }
        }, {
            path: 'paymentcancel',
            name: 'PaymentCancel',
            component: PaymentCancel,
            meta: {
                title: "Paiement annulé",
                requiresAuth: true
            }
        }, {
            path: 'paymentsuccess',
            name: 'PaymentSuccess',
            component: PaymentSuccess,
            meta: {
                title: "Paiement validé",
                requiresAuth: true
            }
        }
        ]
    },
    {
        path: "/agents",
        component: UserMain,
        children: [{
            path: "ulists",
            component: Userslists,
            name: "Userslists",
            meta: {
                title: "liste des Clients",
                requiresAuth: true,
            }
        }, {
            path: "licence",
            component: Licence,
            name: "licence",
            meta: {
                title: "licence",
                requiresAuth: true,
            }
        },
            {
                path: "Liste_principale",
                component: Account,
                name: "account",
                meta: {
                    title: "Liste des Agents",
                    requiresAuth: true
                }
            },
            {
                path: "liste_detaillee",
                component: AccountDetails,
                name: "accountDetails",
                meta: {
                    title: "Détails des Agents",
                    requiresAuth: true
                }
            },
            {
                path: "roles",
                component: Roles,
                name: "Roles",
                meta: {
                    title: "Liste des Rôles",
                    requiresAuth: true
                }
            },
            {
                path: "brigades",
                component: Brigades,
                name: "Brigades",
                meta: {
                    title: "Liste des Brigades",
                    requiresAuth: true
                }
            },
            {
                path: "postes",
                component: Postes,
                name: "Postes",
                meta: {
                    title: "Liste des Postes",
                    requiresAuth: true
                }
            },
            {
                path: "dispatching_regles",
                component: DispatchingRules,
                name: "DispatchingRules",
                meta: {
                    title: "Liste des Règles",
                    requiresAuth: true
                }
            },
            {
                path: "dispatching_resultats",
                component: DispatchingResults,
                name: "DispatchingResults",
                meta: {
                    title: "Résultat des Dispatchings",
                    requiresAuth: true
                }
            },
            {
                path: "dispatching_resultats_agent",
                component: DispatchingResultsByAgent,
                name: "DispatchingResultsByAgent",
                meta: {
                    title: "Résultat des Dispatchings",
                    requiresAuth: true
                }
            },
            {
                path: "dispatching_results_comdeperm",
                component: DispatchingResultsComDePerm,
                name: "DispatchingResultsComDePerm",
                meta: {
                    title: "Résultat des Dispatchings pour Commandant de Permanence",
                    requiresAuth: true
                }
            },
            {
                path: "planning_brigades",
                component: PlanningBrigades,
                name: "PlanningBrigades",
                meta: {
                    title: "Planning par Brigades",
                    requiresAuth: true
                }
            },
            {
                path: "raisons_absence",
                component: Raisons,
                name: "raisons",
                meta: {
                    title: "Raisons Absence",
                    requiresAuth: true
                }
            },
            {
                path: "planning_presences",
                component: Presences,
                name: "Presences",
                meta: {
                    title: "Présences Planifiées",
                    requiresAuth: true
                }
            },
            {
                path: "planning_absences",
                component: Absences,
                name: "absences",
                meta: {
                    title: "Absences Justifiées",
                    requiresAuth: true
                }
            },
            {
                path: "heures_sup",
                component: HeuresSup,
                name: "HeuresSup",
                meta: {
                    title: "Heures Sup",
                    requiresAuth: true
                }
            },
            {
                path: "modifs_journees",
                component: ModifsProvisoires,
                name: "ModifsProvisoires",
                meta: {
                    title: "Modifs Provisoires",
                    requiresAuth: true
                }
            },
            {
                path: "modifs_periodes",
                component: ModifsPermanentes,
                name: "ModifsPermanentes",
                meta: {
                    title: "Modifs Permanentes",
                    requiresAuth: true
                }
            },
            {
                path: "presences_planifiees",
                component: PresencesPlanifiees,
                name: "PresencesPlanifiees",
                meta: {
                    title: "Présences planifiées",
                    requiresAuth: true
                }
            },
            {
                path: "presences_non_planifiees",
                component: PresencesNonPlanifiees,
                name: "PresencesNonPlanifiees",
                meta: {
                    title: "Présences non planifiées",
                    requiresAuth: true
                }
            },
            {
                path: "Shifts",
                component: Shifts,
                name: "Shifts",
                meta: {
                    title: "Shifts personnalisés",
                    requiresAuth: true
                }
            },
            {
                path: "Constantes",
                component: Constantes,
                name: "Constantes",
                meta: {
                    title: "Constantes initiales",
                    requiresAuth: true
                }
            },
            {
                path: "permissions_agent",
                component: PermissionsAgent,
                name: "PermissionsAgent",
                meta: {
                    title: "Agents",
                    requiresAuth: true
                }
            },
            {
                path: "fixation_agents",
                component: FixationAgents,
                name: "FixationAgents",
                meta: {
                    title: "Fixation",
                    requiresAuth: true
                }
            },
            {
                path: "permissions_groupe",
                component: PermissionsGroup,
                name: "PermissionsGroup",
                meta: {
                    title: "groupes",
                    requiresAuth: true
                }
            },
            {
                path: "absences_justifiees",
                component: AbsencesJustifiees,
                name: "AbsencesJustifiées",
                meta: {
                    title: "Absences Justifiées",
                    requiresAuth: true
                }
            },
            {
                path: "absences_non_justifiees",
                component: AbsencesNonJustifiees,
                name: "AbsencesNonJustifiées",
                meta: {
                    title: "Absences non justifiées",
                    requiresAuth: true
                }
            },
            {
                path: "Menus",
                component: Menus,
                name: "Menus",
                meta: {
                    title: "Menus",
                    requiresAuth: true
                }
            },
            {
                path: "Commandes",
                component: Commandes,
                name: "Commandes",
                meta: {
                    title: "Commandes groupées",
                    requiresAuth: true
                }
            },
            {
                path: "CommandesIndividuelles",
                component: CommandesIndividuelles,
                name: "CommandesIndividuelles",
                meta: {
                    title: "Commandes individuelles",
                    requiresAuth: true
                }
            },
            {
                path: "TransfertCommande",
                component: TransfertCommande,
                name: "TransfertCommande",
                meta: {
                    title: "Transfert commande",
                    requiresAuth: true
                }
            },
            {
                path: "RapportsSalarie",
                component: RapportsSalarie,
                name: "RapportsSalarie",
                meta: {
                    title: "Rapports salarié",
                    requiresAuth: true
                }
            },
            {
                path: "QuotePartsSalaries",
                component: QuotePartsSalaries,
                name: "QuotePartsSalaries",
                meta: {
                    title: "Quote parts salariés",
                    requiresAuth: true
                }
            },
            {
                path: "CashierDailyStats",
                component: CashierDailyStats,
                name: "CashierDailyStats",
                meta: {
                    title: "Stats caissiers",
                    requiresAuth: true
                }
            },
            {
                path: "RapportsSalarieAdmin",
                component: RapportsSalarieAdmin,
                name: "RapportsSalarieAdmin",
                meta: {
                    title: "Rapports salarié *",
                    requiresAuth: true
                }
            },
            {
                path: "RapportsRestaurant",
                component: RapportsRestaurant,
                name: "RapportsRestaurant",
                meta: {
                    title: "Rapports restaurant",
                    requiresAuth: true
                }
            },
            {
                path: "RapportsRestaurantAdmin",
                component: RapportsRestaurantAdmin,
                name: "RapportsRestaurantAdmin",
                meta: {
                    title: "Rapports restaurant *",
                    requiresAuth: true
                }
            },
            {
                path: "RapportsNdellice",
                component: RapportsNdellice,
                name: "RapportsNdellice",
                meta: {
                    title: "Rapports Ndellice",
                    requiresAuth: true
                }
            },
            {
                path: "RapportsEntrepriseAdmin",
                component: RapportsEntrepriseAdmin,
                name: "RapportsEntrepriseAdmin",
                meta: {
                    title: "Rapports entreprise *",
                    requiresAuth: true
                }
            },
            {
                path: "RapportsMaay",
                component: RapportsMaay,
                name: "RapportsMaay",
                meta: {
                    title: "Rapports MAAY",
                    requiresAuth: true
                }
            },
            {
                path: "GenerationCodeEmail",
                component: GenerationCodeEmail,
                name: "GenerationCodeEmail",
                meta: {
                    title: "Génération OTP",
                    requiresAuth: true
                }
            },
            {
                path: "UserProfile",
                component: UserProfile,
                name: "UserProfile",
                meta: {
                    title: "Profil utilisateur",
                    requiresAuth: true
                }
            },
            {
                path: "ChangeCredentials",
                component: ChangeCredentials,
                name: "ChangeCredentials",
                meta: {
                    title: "Sécurité",
                    requiresAuth: true
                }
            },
            {
                path: "CommandesMultiples",
                component: CommandesMultiples,
                name: "CommandesMultiples",
                meta: {
                    title: "Commandes Multiples",
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: "/pointages",
        component: TrackingMain,
        children: [{
            path: "pointages",
            component: TrackingLists,
            name: "Trackinglists",
            meta: {
                title: "Pointages Remontés",
                requiresAuth: true,
            }
        },
            {
                path: "infos_tpe",
                component: InfosTPE,
                name: "InfosTPE",
                meta: {
                    title: "Infos TPE remontées",
                    requiresAuth: true,
                }
            },
            {
                path: "statuts_tpe",
                component: StatutsTPE,
                name: "StatutsTPE",
                meta: {
                    title: "Statuts TPE constatés",
                    requiresAuth: true,
                }
            }
        ]
    },
    {
        path: '*',
        component: NotFound
    }

]


const router = new VueRouter({
    routes,
    mode: 'history',
    history: true,
    hashbang: false
})

const DEFAULT_TITLE = "Pointage TSA by Sens NumeriK";

router.afterEach((to) => {
    document.title = to.meta.title || DEFAULT_TITLE;
});

export default router
